/* eslint-disable */
/**
 * This file is included for backwards compatibility only.
 *
 * @deprecated
 */
export default function hasLink(block: any) {
  return block && block.link && block.link.type;
}
